/**
 * Sample Limit Validator
 * Handles validation of decking sample limits and modal display
 */

let modal = null;
let maxSamplesAllowed = parseInt(document.getElementById('sample-limit-modal')?.dataset?.maxSamples) || 6;

// Initializes the validator when the page loads
function init() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => setupModal());
    } else {
        setupModal();
    }
}

// Sets up the modal and adds click events to close buttons
function setupModal() {
    modal = document.getElementById('sample-limit-modal');
    if (modal) {
        const closeButton = document.getElementById('sample-limit-close');
        const modalCloseButton = document.getElementById('modal-close-sample-limit');

        if (closeButton) {
            closeButton.addEventListener('click', () => hideModal());
        }
        if (modalCloseButton) {
            modalCloseButton.addEventListener('click', () => hideModal());
        }
    }
}


function closeQuickViewIfOpen() {

    const productDrawer = document.querySelector("#Product-Drawer");
    // Remove the classes that keep quick-view open
    if (productDrawer) {

        productDrawer.classList.remove("active");
    } else {
        return;
    }

    setTimeout(() => {
        const drawerContent = document.querySelector("#Product-Drawer-Content");
        if (drawerContent) {
            drawerContent.innerHTML = "";
        }
    }, 260);

}

// Calculates how many samples are currently in the cart
// Takes an array of cart items and returns the total sample count
// Distinguish between best-Seller (6 samples) and varied-Width (4 samples)
// Ignores Outdoor Limit Report
function calculateSampleCount(cartItems) {
    let sampleCount = 0;

    cartItems.forEach(item => {
        const tags = item.product_tags || [];
        const productTitle = item.product_title || '';
        const variantTitle = item.variant_title || '';
        const handle = item.handle || '';
        const quantity = parseInt(item.quantity) || 0;

        if (handle === 'outdoor-living-report' || handle === 'style-guide') return;

        if (tags.includes('Sample Kit') || productTitle.toLowerCase().includes('sample kit')) {
            if (variantTitle.toLowerCase().includes('best-seller') || variantTitle.toLowerCase().includes('best seller')) {
                sampleCount += quantity * 6;
            } else if (variantTitle.toLowerCase().includes('varied-width') || variantTitle.toLowerCase().includes('varied width')) {
                sampleCount += quantity * 4;
            }
        } else {
            sampleCount += quantity;
        }
    });

    return sampleCount;
}

// Gets the current cart data from Shopify
// Returns a promise that resolves to the cart data
async function fetchCartData() {
    try {
        const response = await fetch('/cart.js');
        if (!response.ok) {
            throw new Error('Failed to fetch cart data');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching cart data:', error);
        return { items: [] };
    }
}

// Checking if adding a new item would go over the sample limit. Takes a variant ID and quantity, 
// returns true if it's okay to add, false if it would exceed the limit
async function validateAddToCart(variantId, quantity = 1) {
    const cartData = await fetchCartData();
    const currentSampleCount = calculateSampleCount(cartData.items);

    const productData = await findProductByVariantId(variantId);
    const handle = productData?.product?.handle || '';

    // Enforce max 1 for excluded products
    if (handle === 'outdoor-living-report' || handle === 'style-guide') {
        const alreadyInCart = cartData.items.some(item => item.handle === handle);
        return !alreadyInCart;
    }

    const newItemSampleCount = await countSamplesBeingAdded(variantId, quantity);

    const totalAfterAdd = currentSampleCount + newItemSampleCount;

    console.log(`Current samples: ${currentSampleCount}, Adding: ${newItemSampleCount}, Total would be: ${totalAfterAdd}, Limit: ${maxSamplesAllowed}`);

    return totalAfterAdd <= maxSamplesAllowed;
}

// Finds a product and variant by variant ID
async function findProductByVariantId(variantId) {
    const response = await fetch(`/products.json?limit=250`);
    const data = await response.json();

    for (const product of data.products) {
        const variant = product.variants.find(v => v.id == variantId);
        if (variant) {
            return { product, variant };
        }
    }

    return null;
}

// Determines what type of sample kit this is and how many samples it contains
function getSampleKitType(product, variant) {

    const isKit = product.tags.includes('Sample Kit') ||
        product.title.toLowerCase().includes('sample kit');

    if (!isKit) {
        return { isKit: false, samplesPerItem: 1 };
    }

    const variantTitle = variant.title?.toLowerCase() || '';

    if (variantTitle.includes('best-seller') || variantTitle.includes('best seller')) {
        return { isKit: true, samplesPerItem: 6, kitType: 'Best-Seller' };
    } else if (variantTitle.includes('varied-width') || variantTitle.includes('varied width')) {
        return { isKit: true, samplesPerItem: 4, kitType: 'Varied-Width' };
    }
}

// Calculates how many samples would be added with this new item
// Takes a variant ID and quantity, returns the total sample count for this addition
async function countSamplesBeingAdded(variantId, quantity) {
    try {
        const productData = await findProductByVariantId(variantId);

        if (!productData) {
            console.warn('Could not find product/variant data, treating as individual sample');
            return quantity;
        }

        const handle = productData.product.handle || '';
        if (handle === 'outdoor-living-report' || handle === 'style-guide') return 0;

        const { isKit, samplesPerItem, kitType } = getSampleKitType(productData.product, productData.variant);

        if (isKit) {
            console.log(`Adding ${quantity} ${kitType} sample kits (${samplesPerItem} samples each)`);
        }

        return quantity * samplesPerItem;

    } catch (error) {
        console.error('Error determining sample count for new item:', error);
        return quantity;
    }
}

function showModal() {
    if (modal && typeof modal.show === 'function') {
        closeQuickViewIfOpen();
        modal.show();
    } else {
        console.warn('Sample limit modal not found or show method not available');
    }
}

function hideModal() {
    if (modal && typeof modal.hide === 'function') {
        // Remove the class that keeps the opacity of the body when the quick-view is open
        document.body.classList.remove("open-cc--product");
        modal.hide();
    }
}

// Updates the maximum number of samples allowed
function updateLimit(newLimit) {
    maxSamplesAllowed = parseInt(newLimit) || 6;
}

// Create global instance object with public functions
window.sampleLimitValidator = {
    validateAddToCart,
    showModal,
    hideModal,
    updateLimit,
    calculateSampleCount,
    fetchCartData,
    countSamplesBeingAdded
};

init();
